import {
  FORM_FIELD_MOBILE,
  FORM_FIELD_STEP,
  FORM_FIELD_OTP,
} from "../constants/field";
import {
  DEFAULT_PARTNER_CODE,
  AVIVA_PARTNER_CODE,
  DBGB_PARTNER_CODE,
  TERM_PARTNER_CODE,
  SLUG_LOGIN,
} from "../constants";
import { toObject } from "../helpers/utils";
import { Images } from "../constants/images";

export const fields = [FORM_FIELD_MOBILE, FORM_FIELD_STEP, FORM_FIELD_OTP];
export const errorMessageObject = toObject(fields, "");
export const formFields = toObject(fields);
export const initialFormState = {
  ...formFields,
  agree: false,
  alertContent: "",
  hasError: false,
  [FORM_FIELD_MOBILE]: "",
  [FORM_FIELD_OTP]: "",
  [FORM_FIELD_STEP]: SLUG_LOGIN,
};
export const support = {
  [DEFAULT_PARTNER_CODE]: {
    number: "18001037766",
    days: "Monday - Saturday",
    timing: "09:00 AM - 06:00 PM",
  },
  [AVIVA_PARTNER_CODE]: {
    number: "18001037766",
    days: "Monday - Saturday",
    timing: "09:00 AM - 06:00 PM",
  },
  [DBGB_PARTNER_CODE]: {
    number: "18001037766",
    days: "Monday - Saturday",
    timing: "09:00 AM - 06:00 PM",
  },
  [TERM_PARTNER_CODE]: {
    number: "18001037766",
    days: "Monday - Saturday",
    timing: "09:00 AM - 06:00 PM",
  },
};
export const logo = {
  [DEFAULT_PARTNER_CODE]: {
    name: Images.AvivaBOMLogo,
    className: "logo",
  },
  [AVIVA_PARTNER_CODE]: {
    name: Images.AvivaLogo,
    className: "aviva-logo",
  },
  [DBGB_PARTNER_CODE]: {
    name: Images.AvivaBGBLogo,
    className: "aviva-logo",
  },
  [TERM_PARTNER_CODE]: {
    name: Images.AvivaLogo,
    className: "aviva-logo",
  },
};
export const options = {
  gender: [
    { title: "Male", value: "Male" },
    { title: "Female", value: "Female" },
  ],
  banners: [
    {
      label: "Aviva Signature 3D Term Plan",
      imgPath: `${process.env.REACT_APP_FOLDER_NAME}/banner/aviva-signature-3d-term-plan.jpg`,
      visible: false,
      category: "NONPOS",
      partnerSlug: [DEFAULT_PARTNER_CODE],
    },
    {
      label: "Aviva Signature 3D Term Plan",
      imgPath: `${process.env.REACT_APP_FOLDER_NAME}/banner/aviva-signature-3d-term-plan-aviva.jpg`,
      visible: false,
      category: "NONPOS",
      partnerSlug: [AVIVA_PARTNER_CODE, TERM_PARTNER_CODE],
    },
    {
      label: "Aviva Bharat Bal Vikas Yojana",
      imgPath: `${process.env.REACT_APP_FOLDER_NAME}/banner/Aviva-Bharat-Bal-Vikas Yojana.jpg`,
      visible: false,
      category: "POS",
      partnerSlug: [AVIVA_PARTNER_CODE], // DBGB_PARTNER_CODE
    },
    {
      label: "Aviva BOM Partnership",
      imgPath: `${process.env.REACT_APP_FOLDER_NAME}/banner/Aviva-BOM_Mobile Banner.jpg`,
      visible: false,
      category: "NONPOS",
      partnerSlug: [DEFAULT_PARTNER_CODE],
    },
    {
      label: "Aviva Bharat Parivar Yojana",
      imgPath: `${process.env.REACT_APP_FOLDER_NAME}/banner/Aviva Bharat Parivar Yojana_Mobile Banner.jpg`,
      visible: false,
      category: "NONPOS",
      partnerSlug: [DEFAULT_PARTNER_CODE],
    },
    {
      label: "Aviva Bharat Bal Vikas Yojana",
      imgPath: `${process.env.REACT_APP_FOLDER_NAME}/banner/aviva-bal-vikas-mobile-banner.jpg`,
      visible: false,
      category: "POS",
      partnerSlug: [DBGB_PARTNER_CODE],
    },
    {
      label: "Aviva Bharat Bal Vikas Yojana + Bihar Gramin Bank",
      imgPath: `${process.env.REACT_APP_FOLDER_NAME}/banner/aviva-bal-vikas-partnership-bihar-gramin-bank-mobile-banner1.jpg`,
      visible: false,
      category: "POS",
      partnerSlug: [DBGB_PARTNER_CODE],
    },

    // {
    //   label: "Aviva Bharat Bal Vikas Yojana + Bihar Gramin Bank",
    //   imgPath: `${process.env.REACT_APP_FOLDER_NAME}/banner/aviva-bal-vikas-partnership-bihar-gramin-bank-mobile-banner2.jpg`,
    //   visible: false,
    //   category: "POS",
    //   partnerSlug: [DBGB_PARTNER_CODE],
    // },
  ],
};

export const exclusiveBanners = {
  [DEFAULT_PARTNER_CODE]: {
    content: "Exclusively available for Bank of Maharashtra customers.",
  },
  [DBGB_PARTNER_CODE]: {
    content: "Exclusively available for customers of Bihar Gramin Bank.",
  },
};
export const touchFieldsObject = toObject(fields, false);
